// Darstellung von Minuten — gemeinsam für Oberfläche, Push-Texte und Exporte.

/** 465 → "7:45", -30 → "−0:30" (echtes Minuszeichen, damit Excel es nicht als Formel liest). */
export function formatMinutes(minutes: number, options: { sign?: boolean } = {}): string {
  const negative = minutes < 0;
  const abs = Math.abs(Math.trunc(minutes));
  const text = `${Math.floor(abs / 60)}:${String(abs % 60).padStart(2, "0")}`;
  if (negative) return `−${text}`;
  return options.sign && minutes > 0 ? `+${text}` : text;
}

/**
 * Minuten → Dezimalstunden mit zwei Nachkommastellen, für das Lohnbüro.
 * Gerundet wird NUR hier, beim Darstellen der Summe — nie an einer einzelnen Stempelung (FR-03).
 */
export function minutesToDecimalHours(minutes: number): number {
  return Math.round((minutes / 60) * 100) / 100;
}
